// src/pages/imamMahdi/ImpactAppearance.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ImpactAppearance = () => {
  return (
    <>
      <Helmet>
        <title>
          The Global Impact of Imam Mahdi’s (aj) Appearance | Ziyarat Guide
        </title>
        <meta
          name="description"
          content="Explore how the reappearance of Imam Mahdi (aj) will transform the world — ending oppression, spreading justice, and uniting humanity under peace."
        />
        <meta
          property="og:title"
          content="The Global Impact of Imam Mahdi’s (aj) Appearance | Ziyarat Guide"
        />
        <meta
          property="og:description"
          content="Learn how Imam Mahdi’s (aj) arrival will reshape the world with divine justice, compassion, and global unity for all humanity."
        />
        <meta
          property="og:image"
          content="https://ziyaratguide.com/wp-content/uploads/2025/07/Sixth-The-global-impact-of-his-appearance-.png"
        />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="The Global Impact of Imam Mahdi’s (aj) Appearance | Ziyarat Guide"
        />
        <meta
          name="twitter:description"
          content="Imam Mahdi’s reappearance will bring divine justice and peace across nations — discover the global transformation that follows."
        />
      </Helmet>

      <div className="imam-page">
        <div className="imam-content">
          <h1 className="page-title">Impact of His Appearance</h1>

          <div className="content-section">
            <img
              src="https://ziyaratguide.com/wp-content/uploads/2025/07/Sixth-The-global-impact-of-his-appearance-.png"
              alt="Global Impact of Imam Mahdi's Appearance"
              className="imam-image"
            />

            <h2>A World Transformed</h2>
            <p>
              The reappearance of Imam Mahdi (peace be upon him) will not simply
              change governments or laws – it will transform hearts, societies,
              and the entire world order.
            </p>
            <p>
              According to Shia traditions, his appearance marks the beginning
              of an era where:
            </p>
            <ul>
              <li>Oppression and corruption are dismantled</li>
              <li>Justice becomes the universal standard</li>
              <li>Humanity finally lives in true peace and dignity</li>
            </ul>

            <h2>Uniting Hearts Across Nations</h2>
            <p>
              Imam Mahdi’s mission is first and foremost spiritual. He will
              awaken hearts that have long been divided by greed, prejudice, and
              hate.
            </p>
            <p>Narrations describe how:</p>
            <ul>
              <li>
                Differences among people will melt away, replaced by compassion
                and mutual respect.
              </li>
              <li>
                Trust and honesty will become so widespread that people will
                have no need to guard their homes or wealth.
              </li>
            </ul>
            <p>The Prophet Muhammad (pbuh) said:</p>
            <blockquote>
              “He will fill the earth with equity and justice just as it was
              filled with oppression and tyranny. The hearts of the followers of
              Muhammad will be freed from need, and justice will encompass all.”
            </blockquote>

            <h2>Breaking the Back of Tyranny</h2>
            <p>
              Throughout history, powerful regimes have often been built on
              injustice, exploiting the weak.
            </p>
            <p>
              Imam Mahdi will stand against all forms of tyranny, removing
              systems that oppress or exploit. Under his rule:
            </p>
            <ul>
              <li>The poor and vulnerable will be uplifted</li>
              <li>The arrogant and unjust will lose their power</li>
              <li>
                Resources and wealth will be distributed fairly, ending
                structural poverty
              </li>
            </ul>

            <h2>Establishing True Peace</h2>
            <p>
              This is more than just a cessation of war – it is a comprehensive
              peace, rooted in moral and social justice.
            </p>
            <p>Shia traditions explain that under Imam Mahdi’s leadership:</p>
            <ul>
              <li>People will live without fear</li>
              <li>Disputes will be settled with fairness and compassion</li>
              <li>The earth itself will prosper, yielding its blessings</li>
            </ul>

            <h2>A Global Ripple Effect</h2>
            <p>
              Because his mission is divinely supported, its impact will reach
              every corner of the earth.
            </p>
            <p>
              People of all backgrounds and nations will be drawn to his
              leadership, recognising in him the fulfilment of humanity’s
              collective hope for a just and caring world.
            </p>
            <p>
              When Imam Mahdi (aj) appears, he will unite hearts across divides,
              dismantle the systems of oppression that harm the vulnerable, and
              establish a world of lasting peace and justice – fulfilling the
              promise that humanity has long awaited.
            </p>

            <p className="text-sm mt-6">
              © Copyright 2025. All Rights Reserved.
            </p>
          </div>
        </div>

        {/* Sidebar Navigation */}
        <aside className="imam-sidebar">
          <h2>Explore More</h2>
          <ul>
            <li>
              <Link to="/imam-mahdi">Who is Imam Mahdi?</Link>
            </li>
            <li>
              <Link to="/imam-mahdi/described-in-quran-hadith">
                Described In Quran & Hadith
              </Link>
            </li>
            <li>
              <Link to="/imam-mahdi/how-to-talk">How To Talk</Link>
            </li>
            <li>
              <Link to="/imam-mahdi/impact-appearance">
                Impact of His Appearance
              </Link>
            </li>
            <li>
              <Link to="/imam-mahdi/misconceptions">Misconceptions</Link>
            </li>
            <li>
              <Link to="/imam-mahdi/practices-allegiance">
                Practices & Allegiance
              </Link>
            </li>
            <li>
              <Link to="/imam-mahdi/reflections-stories">
                Reflections & Stories
              </Link>
            </li>
            <li>
              <Link to="/imam-mahdi/return">Return</Link>
            </li>
            <li>
              <Link to="/imam-mahdi/signs-reappearance">
                Signs of Reappearance
              </Link>
            </li>
            <li>
              <Link to="/imam-mahdi/supporters">Supporters</Link>
            </li>
            <li>
              <Link to="/imam-mahdi/ultimate-reformer">The Ultimate Reformer</Link>
            </li>
            <li>
              <Link to="/imam-mahdi/why-occultation">Why Occultation</Link>
            </li>
          </ul>
        </aside>
      </div>
    </>
  );
};

export default ImpactAppearance;
